import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import keycloak from 'utils/keycloak';
import KeycloakPubServiceInstance from 'services/keycloakpubsub.service';

const TRACK_KEY = process.env.REACT_APP_TRACK_KEY;
const TRACK_CAMPAIGN = process.env.REACT_APP_TRACK_CAMPAIGN;
const SHOW_TRACK = process.env.REACT_APP_TRACK_SHOW_NPS;
const TrackNPS = () => {
  const user = useSelector((state) => state.user);

  const StartTrack = () => {
    if (SHOW_TRACK) {
      KeycloakPubServiceInstance.subscribe(() => {
        keycloak.loadUserProfile().then((profile) => {
          if (user.email) {
            const ccare_type = profile.attributes.ccare_type?.[0];

            const script = document.createElement('script');

            script.src = 'https://cdn.tracksale.co/tracksale-js/tracksale.js';

            script.async = true;
            document.head.appendChild(script);

            script.onload = () => {
              if (ccare_type && ccare_type.toLowerCase() === 'customer') {
                const data = {
                  key: TRACK_KEY,
                  campaign: TRACK_CAMPAIGN,
                  name: user.email,
                  identification: user.email,
                  email: user.email,
                  salute: '%name.first%, tudo bem?',
                  thanks: 'Obrigado, %name.first%!',
                };
                const trackSale = new window.Tracksale();
                trackSale.init(data);
              }
            };
          }
        });
      });
    }
  };

  useEffect(() => {
    StartTrack();
  }, [user]);

  return <div />;
};

export default TrackNPS;
